import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
import FilterResponse from '../../_helpers/FilterResponse'
import toastr from 'toastr'

export const BuySellServices = {
    getAdminBuysellListing,
    getSubAdminBuySellListing,
    getAllPublishedQuote,
    getParameter,
    saveBuySell,
    requestPublishQuote,
    saveBuySellBehalfUser,
    publishQuote,
    publishQuoteEdit,
    getAllPublishedQuoteByUser,
    whByUserId,
    editCommodityParameter,
    DeteteQuote,
    DeteteQuotebyAdmin,
    getComment,
    commentOnQuote,
    requstSellStatusRequest,
    getBuyerListingOfQuoteRequester,
    saveContractForm,
    getLatlong,
    getAllPublishedQuoteLatLong
}

async function getAdminBuysellListing(offset, limit, queryString) {
    var reuestlink = "/buy-sell-super-admin?" + queryString;
    //+ queryString
    if (offset !== null && limit !== null) {
        reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getSubAdminBuySellListing(offset, limit, queryString) {
    var reuestlink = "/buy-sell-admin?" + queryString;
    //+ queryString
    if (offset !== null && limit !== null) {
        reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getAllPublishedQuote(offset, limit, queryString) {
    var reuestlink = "/all-published-quotes?" + queryString;
    //+ queryString
    if (offset !== null && limit !== null) {
        reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getAllPublishedQuoteLatLong(offset, limit, queryString) {
    var reuestlink = "/all-published-quotes-lat-long?" + queryString;
    //+ queryString
    if (offset !== null && limit !== null) {
       // reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getParameter(id) {
    try {
        const response = await RestMethod.GET("/quality-parameter/"+id);
        const api_response = FilterResponse(response); 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function saveBuySell(data) {
    try {
        const response = await RestMethod.POST("/save-buy-sell",data);
        const api_response = FilterResponse(response); 
        return api_response.data;
    }
    catch (error) {
        if(error && error.status !== 420){
            toastr.error('Something Went Wrong')
        }
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function requestPublishQuote(id, data) {
    try {
        const response = await RestMethod.PUT("/request-buy-sell-quotes/"+id, data);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        console.log(" ",error)
        if(error && error.status !== 420){
            toastr.error('Something Went Wrong')
        }
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function saveBuySellBehalfUser(data) {
    try {
        const response = await RestMethod.POST("/buy-sell-for-user",data);
        const api_response = FilterResponse(response); 
        return api_response.data;
    }
    catch (error) {
        if(error && error.status !== 420){
            toastr.error('Something Went Wrong')
        }
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function publishQuote(id) {
    try {
        const response = await RestMethod.GET("/publish-buy-sell/"+id);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function publishQuoteEdit(id, data) {
    try {
        const response = await RestMethod.PUT("/update-buy-sell/"+id, data);
        return response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getAllPublishedQuoteByUser(offset, limit, queryString) {
    var reuestlink = "/user-buy-sell-quotes?" + queryString;
    //+ queryString
    if (offset !== null && limit !== null) {
        reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function whByUserId(id) {
    try {
        const response = await RestMethod.GET("/users-warehouse/"+id);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function editCommodityParameter(id, data) {
    try {
        const response = await RestMethod.PUT("/update-commodity/"+id, data);
        return response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function DeteteQuote(id) {
    try {
        const response = await RestMethod.GET("/publish-buy-sell/"+id);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function DeteteQuotebyAdmin(id) {
    try {
        const response = await RestMethod.GET("/delete-buy-sell/"+id);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getComment(id) {
    try {
        const response = await RestMethod.GET("/negotiation-details/"+id);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function commentOnQuote(id, data) {
    try {
        const response = await RestMethod.PUT("/negotiation-price/"+id, data);
        return response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function requstSellStatusRequest(id, data) {
    try {
        const response = await RestMethod.PUT("/status-for-buy-sell/"+id, data);
        return response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getBuyerListingOfQuoteRequester(id) {
    try {
        const response = await RestMethod.GET("/buy-quotes/"+id);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function saveContractForm(data) {
    try {
        const response = await RestMethod.POST("/booking-contract",data);
        const api_response = FilterResponse(response); 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getLatlong(location) {
    try {
        const response = await RestMethod.GET("/lat-long?location="+location);
        const api_response = FilterResponse(response); 
        return api_response;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}